<template>
    <div class="card mt-4">
        <h6 class="font-weight-bolder mt-4 mb-2 mx-4">Ocorrências</h6>
        <div v-if="loading" class="text-center my-4">

            <i class="fas fa-spinner fa-pulse"></i>
            <span> Buscando ocorrências</span>
        </div>
        <div v-else class="table-responsive">
            <div ref="scrollContainer" class="table-container" @scroll="handleScroll">
                <table v-if="displayedOccurrences && displayedOccurrences.length > 0"
                    class="table align-items-center mb-0">
                    <thead>
                        <tr>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Chamado</th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                                Abertura</th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="occurrence in displayedOccurrences" :key="occurrence.Nome">
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="mb-0 text-xs">{{ occurrence.Assunto }}</h6>
                                        <p class="text-xs text-secondary mb-0">
                                            {{ occurrence.Nome }}
                                        </p>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ formatDate(occurrence.DataAbertura) }}</p>
                            </td>
                            <td class="align-middle text-center text-sm">
                                <span class="badge badge-sm" :class="getColorStatusDescription(occurrence.Status)">{{
                                    getStatusDescription(occurrence.Status)
                                    }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="text-center my-4">
                    <p class="font-weight-bolder text-primary">Não existem casos abertos.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, computed, ref, watch } from 'vue';
import axios from 'axios';
import { useStore } from "vuex";
import moment from 'moment';

const store = useStore();
const contractData = computed(() => store.getters.getCurrentContract);
const occurrences = ref([]);
const displayedOccurrences = ref([]);
const loading = ref(true);
const itemsPerLoad = 7;
let currentIndex = 0;

const getOccurrences = async () => {
    try {
        displayedOccurrences.value = [];
        occurrences.value = [];
        if (contractData.value && contractData.value.contrato_id) {
            const response = await axios.get(`/contact/occurrences/${contractData.value.contrato_id}`);

            if (response.data.message.length <= 10) {
                displayedOccurrences.value = response.data.message;
            } else {
                occurrences.value = response.data.message;
                loadMoreOccurrences()
            }
        }
    } catch (error) {
        console.log(error);
    } finally {
        loading.value = false;
    }
}

const getStatusDescription = (status) => {
    switch (status) {
        case 'EmAnalise':
            return 'Triagem';
        case 'EmAtendimento':
            return 'Em Atendimento';
        case 'AguardandoRespostaCliente':
            return 'Aguardando Cliente';
        default:
            return status;
    }
}

const getColorStatusDescription = (status) => {
    switch (status) {
        case 'EmAnalise':
        case 'Triagem':
            return 'badge-yellow';
        case 'EmAtendimento':
            return 'badge-blue';
        case 'AguardandoRespostaCliente':
            return 'badge-orange';
        case 'Encerrado':
            return 'badge-green';
        default:
            return 'badge-gray';
    }
}

const formatDate = (dataString) => {
    if (!dataString) return '-'
    const data = moment(dataString, 'YYYY-MM-DD HH:mm:ss');
    return data.format('DD/MM/YY');
};

const loadMoreOccurrences = () => {

    const nextIndex = currentIndex + itemsPerLoad;
    const newOccurrences = occurrences.value.slice(currentIndex, nextIndex);
    displayedOccurrences.value.push(...newOccurrences);
    currentIndex = nextIndex;
}

onMounted(() => {
    getOccurrences();
});

const handleScroll = () => {
    const scrollContainer = document.querySelector('.table-container');
    if (scrollContainer) {
        const { scrollTop, clientHeight, scrollHeight } = scrollContainer;
        if (scrollTop + clientHeight >= scrollHeight) {
            loadMoreOccurrences()
        }
    }
};

const watcherFunction = () => {
    return (newValue, oldValue) => {
        if (newValue && oldValue && typeof newValue === 'object' && typeof oldValue === 'object' && newValue.contrato_unidade !== oldValue.contrato_unidade) {
            loading.value = true;
            getOccurrences();
        }
    };
};
watch(contractData, watcherFunction());
</script>

<style scoped>
.text-center {
    text-align: center;
}

.my-4 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
}

.table-container {
    max-height: 400px;
    /* ajuste essa altura conforme necessário */
    overflow-y: auto;
}

h6 {
    width: 200px;
    /* Defina a largura conforme necessário */
    white-space: nowrap;
    /* Impede a quebra de linha */
    overflow: hidden;
    /* Oculta o texto que excede a largura */
    text-overflow: ellipsis;
    /* Adiciona reticências ao texto truncado */
}

.badge-yellow {
    background-color: #c5c222;
    color: #fff
}

.badge-blue {
    background-color: #22c5bd;
    color: #fff
}

.badge-orange {
    background-color: #c58c22;
    color: #fff
}

.badge-green {
    background-color: #22c55e;
    color: #fff
}

.badge-gray {
    background-color: #939493;
    color: #fff
}
</style>
